export const w = jQuery(window);
export const menu_top = $('#menuTop');
export const menu_top_height = menu_top.outerHeight();
export const document_click_callbacks = [];
